/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_TaglineInputs */

const en_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing, pricing and inventory automation for online sellers.`)
};

const ar_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة القوائم والأسعار والمخزون لبائعي الإنترنت.`)
};

const bn_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনলাইন বিক্রেতাদের জন্য লিস্টিং, মূল্য ও ইনভেন্টরি অটোমেশন।`)
};

const de_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing-, Preis- und Lagerautomatisierung für Online-Händler.`)
};

const es_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización de anuncios, precios e inventario para vendedores online.`)
};

const fr_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation des annonces, des prix et des stocks pour les vendeurs en ligne.`)
};

const pt_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação de anúncios, preços e stock para vendedores online.`)
};

const zh_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给网店卖家的 listing、定价和库存自动化。`)
};

const tr_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çevrimiçi satıcılara listeleme, fiyat ve stok otomasyonu.`)
};

const ru_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация листингов, цен и склада для онлайн-продавцов.`)
};

const pl_svc_ecommerce_amazon_tools_tagline = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja listingów, cen i magazynu dla sprzedawców online.`)
};

/**
* | output |
* | --- |
* | "Listing, pricing and inventory automation for online sellers." |
*
* @param {Svc_Ecommerce_Amazon_Tools_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_tagline = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_tagline(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_tagline(inputs)
	return en_svc_ecommerce_amazon_tools_tagline(inputs)
});
export { svc_ecommerce_amazon_tools_tagline as "svc_ecommerce-amazon-tools_tagline" }